import { createApp } from 'vue'
import { createPinia } from "pinia";
import App from './app/App.vue'
import Toast from 'vue-toastification';
import vSelect from 'vue-select';
import './app/assets/css/main.css'
import './infrastructure/proxies/registerServiceWorker'
import 'vue-toastification/dist/index.css';
import 'vue-select/dist/vue-select.css';
import 'simplebar-vue/dist/simplebar.min.css';
import router from './app/router'
import setupInterceptors from '@/infrastructure/repositories/interceptors/setupInterceptors';

const app = createApp(App);

app.use(createPinia());
app.use(Toast, {});
app.use(router);
app.component('v-select', vSelect);

setupInterceptors();

app.mount('#app')
